import React from 'react';
import {STEPPER} from '../../../../../js/constants/form-types';
import Button from '../../../../ui/button/Button';
import CategoriesFinal from '../../../../../assets/pictos/empty-picto/empty_categories.png';
import UploadFile from '../components/UploadFile';
import Mapping from '../components/Mapping';

const ImportCategories =  {
    titleForm: `Importer des catégories`,
    subTitleForm: 'Veuillez compléter les champs ci-dessous pour importer vos catégories',
    langSelect: false,
    drawerType: 'drawer',
    noForm: true,
    component: Button,
    formConfig: {
        type: STEPPER,
        finalStep: {
            picto: CategoriesFinal,
            title: 'Bientôt prêt !',
            subtitle: 'Votre fichier est prêt à être importé :)',
            textButton: 'Importer le fichier'
        },
        children: [
            {
                labelName: 'Choix du fichier',
                isOptionnal: false,
                component: (props) => {
                    return <UploadFile category={true} {...props} />
                },
                optionsInputs: []
            },
            {
                labelName: 'Mapping',
                isOptionnal: false,
                component: (props) => <Mapping category={true} {...props} />,
                optionsInputs: []
            }
        ]
    }
};

export default ImportCategories;